import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { PacientesService } from '../../services/pacientes/pacientes.service';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent } from 'src/app/models/base-component';
import { GlobalVariable } from 'src/app/global';
import { Util } from 'src/app/utils/utils';
import { PdfService } from 'src/app/base/services/pdf/pdf.service';

declare const PDFDocument:any;
declare const blobStream:any;
declare const aplicarEditor:any;
declare const $:any;

@Component({
    selector: 'app-recetas',
    templateUrl: './recetas.component.html',
    styleUrls: ['./recetas.component.css'],
    standalone: false
})
export class RecetasComponent extends BaseComponent implements OnInit {

  receta:any;
  historia_paciente:any;
  paciente:any;
  especialidad_especialista:any;
  historias_paciente:any[]=[];
  util:any=Util;
  vista:string="";
  @Output() alTerminar:EventEmitter<any>  = new EventEmitter<any>();
  aplicacion_pacientes:any;
  intervalo_autoguardado:any;
  firma_guardada:string;
  guardando:boolean=false;
  guardado_en_curso:Promise<any>=Promise.resolve();
  estado_guardado:string=null;
  fecha_guardado:Date;
  estado_edicion:any=null;
  historia_cerrada:boolean=false;
  desfase_reloj:number=0;
  ahora_ms:number=Date.now();
  intervalo_reloj:any;
  editor_listo:boolean=false;

  constructor(public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    public pacientesService:PacientesService,
    public pdfService:PdfService,
    private toastr: ToastrService) {
      super(persistenciaService,modalService,generalService,usuarioService);
    }

  ngOnInit(): void {
    this.init();
    this.aplicacion_pacientes= this.usuario.aplicacionesUsuario.filter(app_usuario => app_usuario.aplicacion.codigo==GlobalVariable.Dictionary.CODIGO_APP_PACIENTES)[0];
    this.aplicacion_pacientes= this.vista=="citas"?{puede_modificar:true}:this.aplicacion_pacientes;
    if(this.paciente && this.paciente.id){
      let hoy=new Date();
      this.filter={
        id_paciente:this.paciente.id,
        fecha_inicio:null,
        fecha_fin:{ year:hoy.getFullYear(), month:(hoy.getMonth()+1), day:hoy.getDate() }
      };
      this.buscarHistorialPaciente();
    }
    if(this.historia_paciente.descripcion==null){
      this.historia_paciente.descripcion="<p><b>Motivo de Consulta</b></p><ul><li><b>Antecedentes:</b></li><li><b>Medicamentos Actuales:</b></li><li><b>Alergias:</b></li><li><b>Enfermedades Actuales:</b></li><li><b>Signos Vitales:</b></li><li><b>Exploración Física:</b><ul><li><b>Laboratorios</b></li><li><b>Estudios de imágenes</b></li></ul></li><li><b>Observación</b></li></ul>";
    }
    this.cargarEstadoEdicion();
  }

  ngAfterViewInit() {
    aplicarEditor(this);
    this.editor_listo=true;
    if(this.historia_cerrada){
      this.deshabilitarEditor();
    }
  }

  agregarReceta(receta){
    if(this.validarReceta(receta)){
      this.historia_paciente.recetas=this.historia_paciente.recetas?this.historia_paciente.recetas:[];
      this.historia_paciente.recetas.push(receta);
      this.receta={
        id_historia_paciente:this.historia_paciente.id
      } 
    }
  }

  establecerDescripcion(dato){
    this.historia_paciente.descripcion=dato;
  }

  validarReceta(receta){
    let res=true;
    if(!receta.medicamento){
      res=res && false;
      this.toastr.error("Debe especificar el medicamento!");
    }
    if(!receta.cantidad){
      res=res && false;
      this.toastr.error("Debe especificar la cantidad!");
    }
    if(!receta.indicacion){
      res=res && false;
      this.toastr.error("Debe especificar la indicacion!");
    }
    return res;
  }

  async guardarReceta(){
    this.blockUI.start();
    await this.guardado_en_curso;
    let res:any=await this.guardarCambios();
    this.blockUI.stop();
    if(res){
      this.toastr.success(res.mensaje);
      this.alTerminar.emit();
    }else if(!this.historia_cerrada){
      this.toastr.error("No se pudo guardar la historia, intente nuevamente.");
    }
  }

  eliminarReceta(receta){
    if(receta.id){
      receta.eliminado=true;
    }else{
      this.historia_paciente.recetas.splice(this.historia_paciente.recetas.indexOf(receta),1);
    }
  }

  async cerrarComponente(){
    if(this.intervalo_autoguardado){
      await this.guardado_en_curso;
      if(this.hayCambiosSinGuardar()){
        let res=await this.guardarCambios();
        if(!res && !this.historia_cerrada && !confirm("No se pudieron guardar los últimos cambios. ¿Desea cerrar de todas formas?")){
          return;
        }
      }
    }
    this.alTerminar.emit();
  }

  ngOnDestroy(){
    clearInterval(this.intervalo_autoguardado);
    clearInterval(this.intervalo_reloj);
  }

  // ===== Plazo de edición de la historia clínica =====

  cargarEstadoEdicion(){
    if(!this.historia_paciente.id){
      return;
    }
    this.pacientesService.obtenerEstadoEdicionHistoria(this.historia_paciente.id).subscribe((estado:any)=>{
      this.actualizarEstadoEdicion(estado);
      this.iniciarAutoguardado();
      this.intervalo_reloj=setInterval(()=>this.revisarPlazoEdicion(),30000);
    },(error)=>{
      // El servidor igual rechaza los guardados fuera de plazo
      this.iniciarAutoguardado();
    });
  }

  actualizarEstadoEdicion(estado){
    if(!estado) return;
    this.estado_edicion=estado;
    this.desfase_reloj=new Date(estado.hora_servidor).getTime()-Date.now();
    this.ahora_ms=Date.now()+this.desfase_reloj;
    if(estado.cerrada){
      this.cerrarEdicion();
    }
  }

  async revisarPlazoEdicion(){
    this.ahora_ms=Date.now()+this.desfase_reloj;
    if(this.historia_cerrada || !this.estado_edicion || !this.estado_edicion.editable_hasta){
      return;
    }
    if(this.ahora_ms>=new Date(this.estado_edicion.editable_hasta).getTime()){
      await this.guardado_en_curso;
      this.cerrarEdicion();
      this.toastr.warning("Terminó el plazo de "+this.estado_edicion.horas_edicion+" horas: la historia clínica quedó en solo lectura.");
    }
  }

  cerrarEdicion(){
    if(this.historia_cerrada) return;
    this.historia_cerrada=true;
    clearInterval(this.intervalo_autoguardado);
    this.intervalo_autoguardado=null;
    this.deshabilitarEditor();
  }

  deshabilitarEditor(){
    if(this.editor_listo){
      $('#summernote').summernote('disable');
    }
  }

  puedeEditar(){
    return this.aplicacion_pacientes && this.aplicacion_pacientes.puede_modificar && !this.historia_cerrada;
  }

  milisegundosRestantes(){
    return new Date(this.estado_edicion.editable_hasta).getTime()-this.ahora_ms;
  }

  textoTiempoRestante(){
    let minutos=Math.max(0,Math.floor(this.milisegundosRestantes()/60000));
    let horas=Math.floor(minutos/60);
    return horas>0?(horas+" h "+(minutos%60)+" min"):(minutos+" min");
  }

  // ===== Autoguardado =====

  iniciarAutoguardado(){
    if(!this.puedeEditar() || !this.historia_paciente.id){
      return;
    }
    this.firma_guardada=this.obtenerFirma(this.historia_paciente.recetas);
    this.intervalo_autoguardado=setInterval(()=>{
      if(!this.guardando && this.hayCambiosSinGuardar()){
        this.guardarCambios();
      }
    },5000);
  }

  // Huella del contenido editable, para detectar cambios pendientes de guardar
  obtenerFirma(recetas:any[]){
    recetas=recetas||[];
    return JSON.stringify({
      descripcion:this.historia_paciente.descripcion,
      recetas:recetas.filter(r => !r.eliminado).map(r => [r.medicamento,r.presentacion,r.cantidad,r.indicacion]),
      eliminadas:recetas.filter(r => r.eliminado && r.id).map(r => r.id)
    });
  }

  hayCambiosSinGuardar(){
    return this.obtenerFirma(this.historia_paciente.recetas)!=this.firma_guardada;
  }

  guardarCambios():Promise<any>{
    this.guardando=true;
    this.estado_guardado="guardando";
    let recetas=(this.historia_paciente.recetas||[]).slice();
    // Tras guardar, las recetas eliminadas ya no existirán, así que no cuentan en la firma enviada
    let firma_enviada=this.obtenerFirma(recetas.filter(r => !(r.eliminado && r.id)));
    this.guardado_en_curso=new Promise(resolve=>{
      this.pacientesService.guardarReceta(this.historia_paciente.id,{descripcion:this.historia_paciente.descripcion,recetas:recetas}).subscribe((res:any)=>{
        let lista=this.historia_paciente.recetas||[];
        (res.recetas||[]).forEach((r,i)=>{
          let receta=recetas[i];
          if(!r || !receta) return;
          if(r.eliminado){
            if(lista.indexOf(receta)!=-1) lista.splice(lista.indexOf(receta),1);
          }else if(!receta.id && r.id){
            receta.id=r.id;
            // Se quitó de la lista mientras se guardaba: se marca para eliminarla en el próximo guardado
            if(lista.indexOf(receta)==-1){
              receta.eliminado=true;
              lista.push(receta);
            }
          }
        });
        this.firma_guardada=firma_enviada;
        this.guardando=false;
        this.estado_guardado="guardado";
        this.fecha_guardado=new Date();
        this.actualizarEstadoEdicion(res.estado_edicion);
        resolve(res);
      },(error)=>{
        this.guardando=false;
        if(error.status==403 && error.error && error.error.cerrada){
          this.estado_guardado=null;
          this.actualizarEstadoEdicion(error.error.estado_edicion);
          this.toastr.error(error.error.mensaje);
        }else{
          this.estado_guardado="error";
        }
        resolve(null);
      });
    });
    return this.guardado_en_curso;
  }

  buscarHistorialPaciente(){
    this.blockUI.start();
    this.pacientesService.obtenerHistoriasPaciente(this).subscribe((res:any)=>{
      this.blockUI.stop();
      this.historias_paciente=res.historias_paciente;
    });
  }

  verMedicamentosHistoria(h){
    h.mostrar_medicamentos=!h.mostrar_medicamentos;
    if(h.mostrar_medicamentos && !h.medicamentos_cargados){
      h.cargando_medicamentos=true;
      this.pacientesService.obtenerReceta(h.id_historia_paciente).subscribe((res:any)=>{
        h.medicamentos=(res||[]).filter(r => !r.eliminado);
        h.medicamentos_cargados=true;
        h.cargando_medicamentos=false;
      });
    }
  }

  generarPdfReceta(){
    this.pdfService.imprimirRecetaClinica(this.historia_paciente,this.paciente,this.usuario);
  }

  generarPdfRecetaPreimpresa(){
    this.pdfService.imprimirRecetaPreimpresa(this.historia_paciente,this.paciente,this.usuario);
  }

  edadPaciente(){
    let persona=(this.paciente && this.paciente.cliente)?this.paciente.cliente.persona:null;
    return (persona && persona.fecha_nacimiento)?Util.calcularEdad(persona.fecha_nacimiento):null;
  }

}
